export const MATCHA_0X_API_KEY: string = 'a69594bd-4b7d-486d-a164-2e54ea3a6736';
export const EARN_API_URL_DEFAULT = 'https://earn-api.polynomial.fi';
export const API_URL_DEFAULT = 'https://perps-v2-mainnet.polynomial.fi';
export const API_URL_STAGING = 'https://perps-api-staging.polynomial.fi';
export const TRADE_STATS_API_URL_DEFAULT = 'https://trading-stats.polynomial.fi';
export const TRADE_STATS_STAGING_API_URL = 'https://trading-stats-staging.polynomial.fi';
export const REFERRAL_API_URL = 'https://referral-prod-api.polynomial.fi';
export const REFERRAL_API_URL_STAGE = 'https://referral-stage-api.polynomial.fi';
